export default __webpack_public_path__ + "static/media/first_class_desktop_v2.5b36cc07.png";